import { useEffect } from 'react';

import { getAuthSession } from '@/api/auth';
import { useNavigateToReauthenticate } from '@/app/auth/interactiveLogout';

export function SessionExpiredWatcher() {
  const navigateToReauthenticate = useNavigateToReauthenticate();

  useEffect(() => {
    return getAuthSession().onSessionExpired(navigateToReauthenticate);
  }, [navigateToReauthenticate]);

  return null;
}
